import AxiosService from '../../../gateway/rest/AxiosService'

class MssqlUserRestService {
  static async getUsers(): Promise<any> {
    return AxiosService.get('/adaptermssql/users')
  }

  static async createUser(user: any): Promise<any> {
    return AxiosService.post('/adaptermssql/users', user)
  }

  static async deleteUser(id: number): Promise<any> {
    return AxiosService.delete(`/adaptermssql/users/${id}`)
  }
}

export default MssqlUserRestService
